<template>
  <div>
    <div class="bg-no-repeat bg-cover bg-center relative pt-24 pb-40" style="background: url('/dist/images/awiqcp-different-types-of-wood-veneers-and-when-to-use-them-blog-27-v2.jpeg')">
      <div class="bg-black opacity-75 absolute top-0 left-0 h-full w-full" />
      <div class="container text-center relative px-5">
        <h1 class="text-white font-bold md:text-5xl text-2xl">
          Register an Interior Architectural Project
        </h1>
        <div class="flex justify-center">
          <div class="w-full md:w-10/12 px-5">
            <p class="text-white">
              Anyone can register a project. Architects often register new projects during the design phase. <strong>If this step has not been completed when a woodworking company is awarded the contract, that woodworker is required to complete the registration.</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="flex justify-center flex-wrap">
        <div class="w-full md:w-10/12 p-5 bg-white shadow -mt-16 relative mb-5">
          <transition name="fade" mode="out-in">
            <div v-if="submitted" class="text-center py-10">
              <h1>Successfully Submitted</h1>
              <p>Your form has been submitted and will be processed soon.</p>
              <div v-if="submitterProjectRole === 'Woodworker'" class="flex justify-center mt-5">
                <div class="w-full md:w-2/3">
                  <p class="text-2xl font-bold">
                    Next Step
                  </p>
                  <p class="mt-2">
                    Now that you have submitted, you will receive, in the next 24-hours an email from the QCP team with a QCP project number to be included in your specification documents you send out for bid.
                  </p>
                  <p>
                    <em>Mail to:</em> AWI Quality Certification Program, 46179 Westlake Drive, Ste., 120 Potomac Falls, VA 20165
                  </p>
                </div>
              </div>
              <div class="flex justify-center pt-10">
                <d-btn href="https://awiqcp.org/" :flat="['Architect', 'General Contractor'].includes(submitterProjectRole)">
                  Return Home
                </d-btn>
                <d-btn v-if="['Architect', 'General Contractor'].includes(submitterProjectRole)" href="https://awiqcp.org/woodworkers/find-a-qcp-firm/">
                  Find a Firm
                </d-btn>
              </div>
            </div>
            <div v-else class="flex flex-wrap">
              <div class="w-full">
                <transition name="fade" mode="out-in">
                  <page-one v-if="currentPage == 1" />
                  <page-two v-if="currentPage == 2" />
                  <page-three v-if="currentPage == 3" />
                  <page-four v-if="currentPage == 4" />
                  <page-five v-if="currentPage == 5" />
                </transition>
              </div>
            </div>
          </transition>
        </div>

        <div class="w-full md:w-10/12 pb-12">
          <p class="mt-5 font-bold">
            Offline Application
          </p>
          <p class="mb-1">
            If you prefer using an offline registration process,<a target="_blank" href="https://awiqcp.org/wp-content/uploads/2019/11/awi-qcp-project-registration-form-updated.pdf">print and complete this registration form</a>  and mail it to the address below.
          </p>
          <em>Mail to:</em> AWI Quality Certification Program, 46179 Westlake Drive, Ste., 120 Potomac Falls, VA 20165
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { PROJECT_REGISTRATION_FORM } from '@resources/scripts/store/mutation-types';
  import PageOne from './components/RegisterProject/PageOne.vue';
  import PageTwo from './components/RegisterProject/PageTwo.vue';
  import PageThree from './components/RegisterProject/PageThree.vue';
  import PageFour from './components/RegisterProject/PageFour.vue';
  import PageFive from './components/RegisterProject/PageFive.vue';

  const { mapGetters, mapActions } = createNamespacedHelpers('projectRegistrationForm');

  export default {
    parent: true,
    components: {
      PageOne,
      PageTwo,
      PageThree,
      PageFour,
      PageFive,
    },
    props: {
      existingProject: {
        type: Object,
        default: null,
      },
    },
    computed: {
      ...mapGetters([
        'currentPage',
        'submitted',
      ]),

      ...mapFields({
        fields: ['submitterProjectRole'],
        module: 'projectRegistrationForm',
        base: 'formFields',
        mutation: PROJECT_REGISTRATION_FORM.FORM_FIELDS,
      }),
    },

    mounted() {
      if (this.existingProject) {
        this.existingInfoFieldUpdate(this.existingProject);
      }
      this.getCountries();
    },

    methods: {
      ...mapActions([
        'existingInfoFieldUpdate',
        'getCountries',
      ]),
    },
  };
</script>